import { message } from "antd";
import { flow, observable, action } from "mobx";
import { getCloudAccounts, addAccount, saveAccount, deleteAccount } from "services/cloudAccounts";
import { registerHandler } from "services/api";

class CloudAccountsStore {
    constructor() {        
        this.ui = this.getUI();
    }

    @observable
    accounts = []

    getUI = () => {
        let ui = {
            loadingAccounts: false,
            importAccountsDialogVisible: false,
            addAccountDialogVisible: false,
            editAccountDialogVisible: false,
            importingAccounts: false,
            addingAccount: false,
            savingAccount: false,
            testingAccount: false,
            importedAccounts: [],
            currentAccount: null,            
            deletedAccounts: [],
            newAccount: null,
            updatedAccount: null,   
            deletingAccount: false,         
        }
        return observable.object(ui);
    }

    @action
    showAddAccountDialog = () => {
        this.ui.addAccountDialogVisible = true;
    }

    @action
    showEditAccountDialog = (account) => {
        this.ui.editAccountDialogVisible = true;
        this.ui.currentAccount = account;
    }

    @action
    hideEditAccountDialog = () => {
        this.ui.editAccountDialogVisible = false;
        this.ui.currentAccount = null;
    }

    @action
    hideAddAccountDialog = () => {
        this.ui.addAccountDialogVisible = false;
    }

    loadAccounts = flow(function*() {
        this.ui = this.getUI();
        this.ui.loadingAccounts = true;
        const response = yield getCloudAccounts();
        if (response == null) {
            message.error("Failed to load cloud accounts. Unknown error", 5)
            return;
        }
        this.ui.loadingAccounts = false;
        this.accounts = observable.array(response.accounts);
        message.success("Successfully load cloud accounts");

        registerHandler([
			{
				path: "cloud_accounts",
				handler: (err, msg) => {
					if (err) {
						return;
					}
					var obj = JSON.parse(msg.body);

					if (obj.action == "newCloudAccount") {
                        console.log("New cloud account added");
						this.addAccount(obj.account);
						return;
					}
					if (obj.action == "cloudAccountUpdated") {
                        console.log("Cloud account updated");
						this.updateAccount(obj.account);
						return;
					}
                    if (obj.action == "accountDeleted") {
                        console.log("Cloud account deleted");
						this.deleteAccount([obj.account]);
						return;
                    }
				}
			}
		]);

		return;
    })

    @action
	addAccount = account => {
		this.ui.newAccount = observable.object(account);
	};

    @action
	updateAccount = updatedAccount => {
		this.ui.updatedAccount = observable.object(updatedAccount);
	};

    remoteDeleteAccount = flow(function*(id) {
        this.ui.deletingAccount = true;
        const response = yield deleteAccount(id);
        this.ui.deletingAccount = false;
    });

    @action
	deleteAccount = deletedAccounts => {
		this.ui.deletedAccounts = observable.array(deletedAccounts);
        console.log("Deleted accounts is: ", deletedAccounts);
	};

    remoteAddAccount = flow(function*(payload) {
        this.ui.addingAccount = true;
		
		const response = yield addAccount(payload);
		this.ui.addingAccount = false;

		if (response == null) {
			message.error("Failed to add new account. Unknown error", 3);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully added a new account", 3);
		this.ui.addAccountDialogVisible = false;
    })

    saveAccount = flow(function*(payload) {
        this.ui.savingAccount = true;
		
		const response = yield saveAccount(payload);
		this.ui.savingAccount = false;

		if (response == null) {
			message.error("Failed to save the account. Unknown error", 3);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully saved the account", 3);
		this.ui.editAccountDialogVisible = false;
    })
}

export default CloudAccountsStore;